module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-soy.a063e4fa.svg";